import displayError from '@/api/errors/errorResponse'
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormMessage
} from '@/components/forms/form/Form'
import FormWrap from '@/components/forms/form/FormWrap'
import { Button } from '@/components/ui/common/Button'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger
} from '@/components/ui/dialog/Dialog'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useForm } from 'react-hook-form'

import { editDisplayService } from '@/api/services/displays/displaysService'
import { Input } from '@/components/forms/inputs/text/Input'
import { zodResolver } from '@hookform/resolvers/zod'
import { Edit2 } from 'lucide-react'
import { useState } from 'react'
import { z } from 'zod'

const inputSchema = z.object({
  name: z.string().min(1, 'Nazwa jest wymagana')
})

type InputSchema = z.infer<typeof inputSchema>

function DisplayEdit({
  id,
  name,
  advertisementId
}: {
  id: string
  name: string
  advertisementId: string
}) {
  const [open, setOpen] = useState(false)
  const form = useForm<InputSchema>({
    resolver: zodResolver(inputSchema),
    defaultValues: {
      name: name
    }
  })

  const queryClient = useQueryClient()

  const { mutate, isPending } = useMutation({
    mutationFn: (name: string) => editDisplayService(id, { name, advertisementId }),
    onSuccess: async (res) => {
      if (!res.success) return displayError(res)
      setOpen(false)
      await queryClient.invalidateQueries({ queryKey: ['displays'] })
      form.reset()
    }
  })

  const onSubmit = (data: InputSchema) => {
    mutate(data.name)
  }

  return (
    <Dialog onOpenChange={setOpen} open={open}>
      <DialogTrigger asChild>
        <Button
          className="flex flex-row justify-between border-none shadow-none"
          variant={'ghost'}
        >
          Edytuj
          <Edit2 size={16} />
        </Button>
      </DialogTrigger>
      <DialogContent
        aria-describedby="Edytuj wyświetlacz"
        aria-description="Edytuj wyświetlacz"
      >
        <DialogHeader>
          <DialogTitle>Edytuj wyświetlacz</DialogTitle>
        </DialogHeader>
        <Form {...form}>
          <FormWrap onSubmit={form.handleSubmit(onSubmit)}>
            <FormField
              control={form.control}
              name="name"
              render={({ field }) => (
                <FormItem>
                  <FormControl>
                    <Input
                      placeholder="Wpisz nazwę wyświetlacza..."
                      {...field}
                      // error={errors?.creationDescription}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <div className="mt-4 -mb-6 flex items-center justify-end">
              <Button disabled={isPending} type="submit">
                Edytuj
              </Button>
            </div>
          </FormWrap>
        </Form>
      </DialogContent>
    </Dialog>
  )
}

export default DisplayEdit
